<template>
  <div class="container">
    <!-- 面包屑导航 -->
    <breadcrumb-top :breadcrumbConfig="dataList" isBack="1"></breadcrumb-top>
    <!-- 面包屑导航 -->
    <!-- 查询 -->
    <div class="content c-top">
      <breadcrumb-search :breadcrumbSearch="searchList"></breadcrumb-search>
      <div style="margin-bottom: 18px">
        <el-form :inline="true" :model="searchForm" ref="searchForm" size="small">
          <el-form-item label="商品名称" prop="name">
            <el-input v-model="searchForm.name" placeholder="请输入商品名称" style="width: 232px" clearable></el-input>
          </el-form-item>
          <el-form-item label="五域商品编号" prop="goodsNo">
            <el-input v-model="searchForm.goodsNo" placeholder="请输入商品编号" style="width: 232px"></el-input>
          </el-form-item>
          <el-form-item label="商品来源" prop="origin">
            <el-select v-model="searchForm.origin" placeholder="请选择商品来源" style="width: 232px" filterable clearable>
              <el-option v-for="item in originList" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="商品类型" prop="goodsType">
            <el-select v-model="searchForm.goodsType" placeholder="请选择商品类型" style="width: 232px" filterable clearable>
              <el-option v-for="item in goods_types" :key="item.dictId" :label="item.dictName" :value="item.dictId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="状态" prop="status">
            <el-select v-model="searchForm.status" style="width: 232px" placeholder="请选择状态" clearable>
              <el-option v-for="item in dictionaries.sale_status" :key="item.dictId" :label="item.dictName"
                :value="item.dictId">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="商品类目" prop="categoryIds">
            <el-cascader style="width: 232px" :options="categoryIds" v-model="searchForm.categoryIds"
              :props="{ checkStrictly: true, multiple: true, emitPath: false }" @change="onChangeCategory" collapse-tags
              clearable></el-cascader>
          </el-form-item>
          <el-form-item label="分类标签" prop="tagId" label-width="96px">
            <el-select v-model="searchForm.tagId" style="width: 232px;" placeholder="请选择分类标签" clearable filterable>
              <el-option v-for="item in tags" :key="item.id" :label="item.tagName" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="fetchData('search')">查询</el-button>
            <el-button type="primary" plain @click="fetchData('reset')">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="content">
      <h3 style="font-weight: bold">
        列表数据<span style="color: #f63c56; font-size: 14px; margin-left: 12px">剩余可上架数量（{{ surNum }}）</span>
      </h3>
      <div class="btn-list">
        <div class="item">
          <el-radio-group v-model="radio1" @change="selectData">
            <el-radio-button label=" " border>全部({{
              countGroupByStatus.psGoodsTotalUp +
              countGroupByStatus.psGoodsTotalDown
            }})</el-radio-button>
            <el-radio-button label="1">已上架({{ countGroupByStatus.psGoodsTotalUp }})</el-radio-button>
            <el-radio-button label="0">已下架({{
              countGroupByStatus.psGoodsTotalDown
            }})</el-radio-button>
          </el-radio-group>
        </div>
        <div class="item">
          <el-button type="warning" style="width: 92px" @click="toApply()" :disabled="currentStatus === groupByStatus.onSaleCount ? true : false
              ">商品审核</el-button>
          <el-button type="warning" style="width: 106px" @click="toAwait()" :disabled="currentStatus === groupByStatus.offSaleCount ? true : false
            ">待上架商品</el-button>
          <el-button type="primary" style="width: 142px" icon="el-icon-edit" @click="toEditTag()">批量修改标签</el-button>
          <el-button type="primary" @click="add" icon="el-icon-plus">添加商品</el-button>
          <el-button type="primary" @click="exportData()" icon="el-icon-upload2">批量导出</el-button>
        </div>
      </div>
      <div id="base-list">
        <lb-table v-horizontal-scroll="'always'" :column="columns" :data="list" pagination :total="page.totalNum"
          layout="total, sizes, prev, pager, next, jumper" :page-sizes="[5, 10, 20, 30, 50]"
          :current-page.sync="searchForm.pageNo" :page-size="searchForm.pageSize" @selection-change="onMultipleSelection"
          @size-change="handleSizeChange" @p-current-change="handleCurrentChange">
        </lb-table>
      </div>
    </div>
    <el-dialog title="温馨提示" :visible.sync="isLimit" width="518px" :append-to-body="true">
      <template>
        <div class="info">
          <i class="el-icon-warning" style="color: orange; font-size: 20px"></i>您已新增上架商品
          {{ numberY }}
          个，已达新增上架商品上限，若想继续新增商品，请下架其中一个商品；
        </div>
        <div class="info-b">
          <span style="color: red">*</span> 若增加上架个数，请联系客服！
        </div>
        <div style="display: flex; justify-content: end; margin-top: 24px">
          <div class="info-q" @click="isLimit = false">取消</div>
          <div class="info-s" @click="sLimit()">确定</div>
          <!-- <el-button type="primary" plain @click="isUp = false">取消</el-button>
          <el-button type="primary" @click="isUp = false">确定</el-button> -->
        </div>
      </template>
    </el-dialog>
    <!-- <el-dialog title="温馨提示" :visible.sync="isSup" width="518px" :append-to-body="true">
      <template>
        <div class="info" style="text-align: left">
          <i class="el-icon-warning" style="color: orange; font-size: 20px"></i>当前商品已上架第三方平台，是否确认下架？
        </div>
        <div class="info-b">下架后所有平台都下架该商品！</div>
        <div style="display: flex; justify-content: end; margin-top: 24px">
          <div class="info-q" @click="isSup = false">取消</div>
          <div class="info-s" @click="sUpData">确定</div>
        
        </div>
      </template>
    </el-dialog> -->
    <el-dialog title="温馨提示" :visible.sync="isSdown" width="518px" :append-to-body="true">
      <template>
        <div class="info" style="text-align: left">
          <i class="el-icon-warning" style="color: orange; font-size: 20px"></i>该商品五域系统已下架，平台不能再上架！
        </div>
        <div style="display: flex; justify-content: end; margin-top: 24px">
          <div class="info-q" @click="isSdown = false">取消</div>
          <div class="info-s" @click="isSdown = false">确定</div>
          <!-- <el-button type="primary" plain @click="isUp = false">取消</el-button>
          <el-button type="primary" @click="isUp = false">确定</el-button> -->
        </div>
      </template>
    </el-dialog>
    <el-dialog title="温馨提示" :visible.sync="isSdown1" width="518px" :append-to-body="true">
      <template>
        <div class="info" style="text-align: left">
          <i class="el-icon-warning" style="color: orange; font-size: 20px"></i>来源平台下架，同步的所有平台都下架!
        </div>
        <div style="display: flex; justify-content: end; margin-top: 24px">
          <div class="info-q" @click="isSdown1 = false">取消</div>
          <div class="info-s" @click="sUpData">确定</div>
          <!-- <el-button type="primary" plain @click="isUp = false">取消</el-button>
          <el-button type="primary" @click="isUp = false">确定</el-button> -->
        </div>
      </template>
    </el-dialog>
    <el-dialog title="选择标签" :visible.sync="isTag" width="40%" :append-to-body="true">
      <template>
        <div>
          <div style="display: flex">
            <div style="line-height: 30px">标签名称</div>
            <div style="margin-left: 20px">
              <el-input placeholder="请输入标签名称" size="small" v-model="name"></el-input>
            </div>
            <div style="margin-left: 20px">
              <el-button type="primary" @click="fetchData1('search')" size="small">查询</el-button>
              <el-button type="primary" plain @click="fetchData1('reset')" size="small">重置</el-button>
            </div>
          </div>
          <div style="margin-top: 20px">
            <lb-table v-horizontal-scroll="'always'" :column="columnsT" :data="tagList" pagination :total="totalNum"
              layout="total, sizes, prev, pager, next, jumper" :page-sizes="[5, 10, 20, 30, 50]"
              :current-page.sync="pageNo" :page-size="pageSize" @selection-change="onMultipleSelection"
              @size-change="handleSizeChange1" @p-current-change="handleCurrentChange1">
            </lb-table>
          </div>
        </div>
        <div style="display: flex; justify-content: center; margin-top: 24px">
          <!-- <div class="info-q" @click="isTag = false">取消</div> -->
          <div class="info-s" @click="upTags()">确定</div>
          <!-- <el-button type="primary" plain @click="isUp = false">取消</el-button>
          <el-button type="primary" @click="isUp = false">确定</el-button> -->
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script >
import LbTable from '../../../components/lb-table/lb-table'
import breadcrumbTop from '../../../components/breadcrumb.vue'
import breadcrumbSearch from '../../../components/breadcrumbSearch.vue'
import Label from '../components/label.vue'
import ModifyState from '../components/ModifyState.vue'
import mixinsGiftlist from '../mixins/mixinsGiftlist.js'
export default {
  mixins: [mixinsGiftlist],
  components: {
    Label,
    LbTable,
    breadcrumbTop,
    ModifyState,
    breadcrumbSearch
    // BaseList
  },
  data() {
    return {
      pageNo: 1,
      pageSize: 10,
      tagList: [],
      totalNum: 0,
      name: '',
      isTag: false,
      isSdown: false,
      isSdown1: false,
      isSup: false,
      isLimit: false,
      radio1: ' ',
      isUp: 'up',
      searchList: {
        list: [
          { title: '商品列表', path: '', type: '0' },
          { title: '数据筛选', path: '', type: '1' }
        ]
      },
      shopLists: [
        {
          skuNo: '1',
          name: 'cdd',
          retailPrice: 36
        },
        {
          skuNo: '1',
          name: 'cdd',
          retailPrice: 36
        },
        {
          skuNo: '1',
          name: 'cdd',
          retailPrice: 36
        },
        {
          skuNo: '2',
          name: 'cdd',
          retailPrice: 36
        },
        {
          skuNo: '2',
          name: 'cdd',
          retailPrice: 36
        },
        {
          skuNo: '3',
          name: 'cdd',
          retailPrice: 36
        },
        {
          skuNo: '4',
          name: 'cdd',
          retailPrice: 36
        },
        {
          skuNo: '4',
          name: 'cdd',
          retailPrice: 36
        },
      ],
      title: '批量上架',
      isShow: false,
      GoodsExportLoading: false,
      goods_types: [
        {
          dictId: '1',
          dictName: '普通商品'
        },
        {
          dictId: '3',
          dictName: '赠品'
        }
      ],
      dataList: {
        list: [
          { title: '商品管理', path: '', type: '0' },
          { title: '商品列表', path: '', type: '1' }
        ]
      },
      searchForm: {
        name: '', // 	否 	string 	商品名称
        platformGoodsNo: '', // 	否 	string 	商品编号
        categoryIds: [], // 	否 	int 	类目id（数据来源：接口 - /order/comm/commodityCategory/commList）
        goodsType: '', // 	否 	int 	类型（1：普通商品；2：虚拟商品；3：赠品；字典：goods_type）
        status: '', // 	否 	int 	状态（字典：sale_status）
        origin: '',//来源
        pageNo: 1,
        pageSize: 10,
        goodsNo: '',
        tagId: ''
      },
      tags: [],
      currentStatus: 100, // 当前列表状态
      groupByStatus: { // 数据切换
        totalCount: 100, // 全部
        onSaleCount: 200, // 上架中商品
        offSaleCount: 300 // 已下架商品
      },
      countGroupByStatus: { // 商品列表数量统计
        psGoodsTotalDown: 0,
        psGoodsTotalUp: 0,
        psGoodsTotalWait: 0,
        total: 0,
        psGoodsTotal: 0
      },
      // 数据列表
      list: [],
      loading: false,
      categoryList: [], // 目类列表
      brandList: [], // 品牌
      originList: [
        {
          id: 1,
          name: '平台上架'
        },
        {
          id: 2,
          name: '五域上架'
        },
      ],//来源列表
      categoryIds: [],
      columnsT: [
        { label: '标签名称', prop: 'tagName', minWidth: '120', align: 'center' },
        {
          label: '排序', prop: 'sort', minWidth: '140', align: 'center'
        },
        {
          label: '状态', prop: 'statusLabel', minWidth: '120',
          render: (h, scope) => {
            let vv = ''
            if (scope.row.statusLabel == '启用') {
              vv = <p style="color:#303033;font-size:14px;display:flex;justify-content:start;"><div style="width: 10px;height: 10px;background: #13CE4B;border-radius: 50%;opacity: 1;margin-top:7px;margin-right:4px"></div>
                <div>{scope.row.statusLabel}</div>
              </p>
            } else {
              vv = <p style="color:#303033;font-size:14px;display:flex;justify-content:start;"><div style="width: 10px;height: 10px;background:  #F63C56;border-radius: 50%;opacity: 1;margin-top:7px;margin-right:4px"></div>
                <div>{scope.row.statusLabel}</div>
              </p>
            }
            return (
              <div> {vv}</div>
            )
          }
        },
        {
          label: '操作',
          minWidth: '100',
          align: 'center',
          render: (h, scope) => {
            return (
              <div>
                <el-switch
                  onChange={() => { this.isUpTag(scope.row) }}

                  v-model={scope.row.checkedL}
                  active-color="#2D46EE"
                  inactive-color="#EBEEFA">
                </el-switch>
                {/* <p class={scope.row.status === 1 ? 'success' : 'danger'}>{scope.row.statusLabel}</p> */}
              </div>
            )
          }
        },

      ],
      columns: [
        { type: 'selection', minWidth: '80', fixed: 'left' },

        {
          label: '平台商品信息',
          width: '300',
          render: (h, scope) => {
            return (
              <div style="display:flex;">
                <el-image style="width:64px;height:64px;margin-right:8px;" src={scope.row.mainImageArr[0]} preview-src-list={scope.row.mainImageArr} lazy></el-image>
                <div style="text-align:left;flex:1;">
                  <div style="width:100%;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:2;text-overflow:ellipsis;overflow:hidden;">
                    {scope.row.name}
                  </div>
                  <p>平台商品编号：{scope.row.platformGoodsNo}</p>
                </div>
              </div>
            )
          }
        },
        { label: '五域商品编号', prop: 'goodsNo', minWidth: '120' },
        {
          label: '分类标签', prop: 'tagNames', minWidth: '100',
        },
        {
          label: '商品来源', prop: 'isMyOutputLabel', minWidth: '100',
        },
        { label: '商品类目', prop: 'categoryName', minWidth: '120' },
        { label: '商品类型', prop: 'goodsType', minWidth: '90' },

        { label: '商品库存', prop: 'stock', minWidth: '90' },
        // { label: '价格', prop: 'marketPrice', minWidth: '120', sortable: true },
        { label: '发布时间', prop: 'createdTime', width: '170' },

        {
          label: '是否上架',
          minWidth: '100',
          render: (h, scope) => {
            return (
              <div>
                <el-switch
                  onChange={() => { this.isUpShop(scope.row) }}
                  active-text="是"
                  inactive-text="否"
                  v-model={scope.row.statusL}
                  active-color="#2D46EE"
                  inactive-color="#EBEEFA">
                </el-switch>
                {/* <p class={scope.row.status === 1 ? 'success' : 'danger'}>{scope.row.statusLabel}</p> */}
              </div>
            )
          }
        },
        {
          label: '操作',
          minWidth: '130',

          renderHeader: (h, scope) => {
            return (
              <div>
                <span >操作</span>
              </div>
            )
          },
          render: (h, scope) => {
            return (
              <div>
                <span style='color:#2D46EE;cursor:pointer;' onClick={() => { this.toOtherPages('shopEdit', scope.row, 'edit') }}>查看/编辑</span>
                <span style='color:#2D46EE;cursor:pointer;margin-left:20px' onClick={() => { this.editTag(scope.row, 'edit') }}>修改标签</span>
              </div>
            )
          }
        }],
      page: { pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1, status: '' },
      dialog: { visible: false, title: '编辑', type: '', row: {}, list: [], batch: false, titleArr: [] },
      dictionaries: { // 字典数据
        sale_status: [], // 状态
        goods_type: [] // 商品类型
      },
      selectionGoods: [], // 选 中 商品
      parArray: [],// 按钮权限
      numberY: 0,
      surNum: 0,
      cRow: {},
      pageNo: 1,
      pageSize: 10,
      psGoodsIds: [],
      searchFormT: {
        tagName: '',
        status: '',
        createdTimeStart: "",
        createdTimeEnd: '',
        pageNo: 1,
        pageSize: 1000000
      },
    }
  },
  mounted() {

  },
  created() {
    this.getDictionaries('goods_type')
    this.getDictionaries('sale_status')
    this.getCategoryList()
    this.fetchData()
    this.getPlatform()
    this.getPlatformInfo()
    this.getTList()
  },
  methods: {
    getTList() {
      this.axios.post('/tags/pageList', this.searchFormT)
        .then(res => {
          console.log(res)
          // res.data.list.forEach(item => {
          //   if (item.status == true) {
          //     item.statusLabel = '启用'
          //     item.statusL = '禁用'
          //   } else {
          //     item.statusLabel = '禁用'
          //     item.statusL = '启用'
          //   }
          // })
          this.tags = res.data.list;
          // this.page.totalNum = res.data.totalNum;
        })
    },
    upTags() {
      this.isTag = false
      this.fetchData()
    },
    isUpTag(row) {
      console.log(row)
      let status = 0
      if (row.checked == 0) {
        status = 1
      } else {
        status = 0
      }
      let data = {
        id: row.id,
        status: status,
        psGoodsIds: this.psGoodsIds
      }
      this.axios.post('/psTag/updatePsTag', data).then(res => {
        if (res.code == 0) {
          this.$message.success('更改成功')
        }
      })
    },
    //修改标签
    editTag(val) {
      this.name = ''
      this.psGoodsIds = []
      // this.selectionGoods = []
      this.psGoodsIds = []
      this.pageNo = 1
      this.isTag = true
      // this.selectionGoods.push(val)
      this.psGoodsIds.push(val.id)
      // console.log(this.selectionGoods)
      // this.getTags()
      let data = {
        psGoodsIds: this.psGoodsIds,
        name: this.name,
        pageNo: this.pageNo,
        pageSize: this.pageSize
      }
      this.axios.post('/psTag/tagePageList', data).then(res => {
        if (res.code == 0) {
          res.data.list.forEach(item => {
            if (item.status == 1) {
              item.statusLabel = '启用'
            } else {
              item.statusLabel = '禁用'
            }
            if (item.checked == 0) {
              item.checkedL = false
            } else {
              item.checkedL = true
            }
          })
          this.tagList = res.data.list
          this.totalNum = res.data.totalNum
        }
      })
    },
    //批量修改标签
    toEditTag() {
      this.name = ''
      if (this.selectionGoods.length == 0) {
        this.$message.warning('请选择商品')
        return
      } else {
        this.isTag = true
        console.log(this.selectionGoods)
        this.getTags()
      }
    },
    fetchData1(val) {
      if (val == 'reset') {
        this.pageNo = 1
        this.name = ''
      } else if (val == 'search') {
        this.pageNo = 1

      }

      this.getTags1()
    },
    getTags1() {
      // this.psGoodsIds = []
      // this.selectionGoods.forEach(item => {
      //   this.psGoodsIds.push(item.id)
      // })
      let data = {
        psGoodsIds: this.psGoodsIds,
        name: this.name,
        pageNo: this.pageNo,
        pageSize: this.pageSize
      }
      this.axios.post('/psTag/tagePageList', data).then(res => {
        if (res.code == 0) {
          res.data.list.forEach(item => {
            if (item.status == 1) {
              item.statusLabel = '启用'
            } else {
              item.statusLabel = '禁用'
            }
            if (item.checked == 0) {
              item.checkedL = false
            } else {
              item.checkedL = true
            }
          })
          this.tagList = res.data.list
          this.totalNum = res.data.totalNum
        }
      })
    },
    getTags() {
      this.psGoodsIds = []
      this.selectionGoods.forEach(item => {
        this.psGoodsIds.push(item.id)
      })
      let data = {
        psGoodsIds: this.psGoodsIds,
        name: this.name,
        pageNo: this.pageNo,
        pageSize: this.pageSize
      }
      this.axios.post('/psTag/tagePageList', data).then(res => {
        if (res.code == 0) {
          res.data.list.forEach(item => {
            if (item.status == 1) {
              item.statusLabel = '启用'
            } else {
              item.statusLabel = '禁用'
            }
            if (item.checked == 0) {
              item.checkedL = false
            } else {
              item.checkedL = true
            }
          })
          this.tagList = res.data.list
          this.totalNum = res.data.totalNum
        }
      })
    },
    sLimit() {
      this.isLimit = false
      this.fetchData()
    },
    getPlatformInfo() {
      this.axios.get('/sys/platformInfo', {}).then(res => {
        if (res.code == 0) {
          if (this.surNum == 0) {
            this.numberY = res.data.productCount
          }
        }
      })
    },
    sUpData() {
      let data = {
        id: this.cRow.id,
        type: 0
      }
      this.axios.post('/goods/upPsGoods', data).then(res => {
        if (res.code == 0) {
          this.$message.success('操作成功')
          this.isSdown1 = false
          this.fetchData()
        }
      })
    },
    isUpShop(row) {
      console.log(row)
      this.cRow = row
      let type = null
      if (row.status == 1) {
        row.statusL = true
      } else {
        row.statusL = false
      }
      // if (row.upOtherPlatform == true && row.isOrigin == 1) {
      //   this.isSup = true
      //   return
      // }
      if ((row.statusL == false && row.wyDownTime != null && row.platformIdOrigin != 0 && row.platformId != row.platformIdOrigin) || (row.statusL == false && row.wyDownTime != null && row.platformIdOrigin == 0)) {
        this.isSdown = true
        return
      }
      if (row.platformId == row.platformIdOrigin && row.statusL == true) {
        this.isSdown1 = true
        return
      }
      if (row.statusL == false && this.surNum == 0 && row.platformIdOrigin != 0 && row.platformIdOrigin == row.platformId) {
        this.isLimit = true
        return
      }
      if (row.statusL == false) {
        type = 1
      } else {
        type = 0

      }
      let data = {
        id: row.id,
        type: type
      }
      this.axios.post('/goods/upPsGoods', data).then(res => {
        if (res.code == 0) {
          this.$message.success('操作成功')
          this.fetchData()
        } else {
          this.fetchData()
        }
      })
    },
    getPlatform() {
      this.axios.get('/sys/platformInfo', {}).then(res => {
        if (res.code == 0) {
          this.surNum = res.data.platformInfo.maxGoodsNum - res.data.productCount
        }
      })
    },
    toApply() {
      this.$router.push({
        name: 'shopApply',
        query: {}
      })
    },
    toAwait() {
      this.$router.push({
        name: 'pendingShop',
        query: {}
      })
    },
    exportData() {
      let params = {

      }
      params = Object.assign(params, this.searchForm)
      this.axios.post('/goods/psGoodsExport', params).then((res) => {
        this.downloadlink(res.data)
        this.$message.success('操作成功！')
      }).catch((err) => {
        this.GoodsExportLoading = false
        console.log(err)
      })
    },
    downloadlink(url) {
      const protocol = location.protocol
      let resultUrl = url
      if (protocol === 'https:') {
        resultUrl = url.replace(`http:`, `${protocol}`)
      }
      const iframe = document.createElement('iframe')
      iframe.style.display = 'none'
      iframe.src = resultUrl
      document.body.appendChild(iframe)
    },
    selectData() {
      if (this.radio1 == ' ') {
        this.searchForm.status = ''
        // this.radio1 = ''
      } else {
        this.searchForm.status = this.radio1
      }

      this.fetchData()
    },
    // 获取字典数据
    getDictionaries(type) {
      this.axios.get('/sys/dictByGroup', {
        params: {
          groupId: type
        }
      })
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            this.dictionaries[type] = res.data
          }
        })
    },
    add() {
      this.axios.get('/sys/platformInfo', {}).then(res => {
        if (res.code == 0) {
          if (this.surNum == 0) {
            this.isLimit = true
            this.numberY = res.data.productCount
          } else {
            this.isLimit = false
            this.$router.push({
              name: 'addGoodsCategory',
              query: {}
            })
          }
        }
      })
      // this.$router.push({
      //   name: 'addGoodsCategory',
      //   query: {}
      // })
    },
    changeUp(val) {
      this.isUp = val
    },
    //表格合并行和列
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      let pos = 0
      let len = this.shopLists.length
      for (let i = 0; i < len; i++) {
        const item = this.shopLists[i]
        if (i === 0) {
          item.$rows = 1
          pos = 0
        }
        if (i !== 0) {
          if (item.skuNo === this.shopLists[i - 1].skuNo) {
            item.$rows = 0
            this.shopLists[pos].$rows = this.shopLists[pos].$rows + 1
          } else {
            item.$rows = 1
            pos = i
          }
        }
      }
      if (columnIndex === 0) {
        return {
          rowspan: row.$rows,
          colspan: row.$rows ? 1 : 0,
        };
      }
    },
    getretailPrice(title, row) {
      this.dialog.visible = true
      if (title == 'retailPrice') {
        this.dialog.title = '零售价'
      } else if (title == 'stock') {
        this.dialog.title = '可用库存'
      } else {
        this.dialog.title = '销量'
      }
      this.dialog.width = '640px'
      this.dialog.type = title
      this.dialog.list = row.skuList
    },
    fetchData(type) {
      this.loading = true;
      if (type == 'reset') {
        // 
        this.searchForm = {}
        this.searchForm.pageNo = 1
        this.searchForm.pageSize = 10
        this.searchForm.categoryIds = []
      }
      if (type == 'search') {
        this.searchForm.pageNo = 1
        this.searchForm.pageSize = 10
      }
      console.log(this.searchForm)
      this.axios.post('/goods/pageList', this.searchForm).then((res) => {
        if (res.code === 0) {
          res.data.list.forEach(e => {
            e.marketPrice = Number(e.marketPrice)
            e.stock = Number(e.stock)
            e.soldNum = Number(e.soldNum)
            e.mainImageArr = []
            e.mainImageArr.push(e.mainImage)
            if (e.isMyOutput == 1) {
              e.isMyOutputLabel = '平台上架'
            } else {
              e.isMyOutputLabel = '五域上架'
            }
            if (e.tagNames) {
              e.tagNames = e.tagNames
            } else {
              e.tagNames = '-'
            }
            e.skuList.forEach(it => {
              it.skuNo = e.goodsNo + it.skuNo
            })
            // e.statusL = false
            if (e.status == 1) {
              e.statusL = true
            } else {
              e.statusL = false
            }
          })

          this.list = res.data.list
          console.log(this.list)
          this.page.totalNum = res.data.totalNum
        } else {
          console.log('goodsPageList - 失败', type)
        }
        this.loading = false;
      }).catch((err) => {
        this.loading = false;
        console.log(err)
      })
      this.getCountGroupByStatus()// 获取商品列表数量统计
      this.getPlatform()
    },
    handleCurrentChange(currentChange) {
      this.searchForm.pageNo = currentChange
      this.fetchData()
    },
    handleSizeChange(sizeChange) {
      this.searchForm.pageSize = sizeChange
      this.fetchData()
    },
    handleCurrentChange1(currentChange) {
      this.pageNo = currentChange
      this.fetchData1()
    },
    handleSizeChange1(sizeChange) {
      this.pageSize = sizeChange
      this.fetchData1()
    },
    getButtonTreeDto() {
      // 获取权限设定
      this.limits = JSON.parse(sessionStorage.getItem('limit'))
      const params = this.limits.buttonTreeDto.filter(
        (item) => item.menuCode === 'companyCode'
      )
      params[0].buttonList.forEach((item) => {
        this.parArray.push(item.code)
      })
    },
    // 获取字典数据
    getDictionaries(type) {
      if (type && this.dictionaries[type].length > 0) { return }
      const params = { groupId: type }
      this.$api.dictionaries(params).then((res) => {
        this.dictionaries[type] = res.data
      }).catch((err) => {
        console.log(err)
      })
    },
    // 获取商品列表数量统计
    getCountGroupByStatus() {
      const params = {}
      this.axios.post('/goods/statistics', this.searchForm).then((res) => {
        this.countGroupByStatus = res.data
      }).catch((err) => {
        console.log(err)
      })
    },
    // 获取类目列表
    getCategoryList() {
      let data = {
        pageNo: 1,
        pageSize: 10000,
        categoryName: '',
        categoryNo: '',
        status: null
      }
      this.axios.get('/goods/categoryPageList', {
        params: data

      })
        .then(res => {
          console.log(res)
          if (res.code == 0) {
            this.categoryIds = res.data.list
          }
        })
    },
    // 获取 品牌 列表
    getBrandList() {
      const params = { pageNo: 1, pageSize: 999 }
      this.$api.brandCommList(params).then((res) => {
        this.brandList = res.data.list
      }).catch((err) => {
        console.log(err)
      })
    },
    // 搜索 选择 类目
    onChangeCategory(val) {
      // this.search.classId = val[val.length -1]
      // console.log(val, this.search.classId)
    },
    // 切换当前列表
    onChangeList(state) {
      this.page = { pageNo: 1, pageSize: 10, totalNum: 0, currentPage: 1 }
      this.currentStatus = state
      // if ( this.currentStatus === this.assignStatus.all) {}
      if (this.currentStatus === this.groupByStatus.totalCount) { this.fetchData('all') }
      if (this.currentStatus === this.groupByStatus.onSaleCount) { this.fetchData('up') }
      if (this.currentStatus === this.groupByStatus.offSaleCount) { this.fetchData('down') }
    },
    // 多选
    onMultipleSelection(val) {
      this.selectionGoods = val
    },
    // 上架、下架
    async operationStatus(type, row) {
      this.isShow = true
      if (type == 'up') {
        this.title = '批量上架'
      } else {
        this.title = '批量下架'
      }
      return
      console.log(type, row)
      let msg = type === 'up' ? `是否上架商品, 是否继续?` : `是否下架商品, 是否继续?`
      const params = { ids: [] }
      const selectionId = []
      const titleArr = []
      const selectionGoods = this.selectionGoods
      selectionGoods.forEach(e => { selectionId.push(e.id) })
      if (row) {
        this.dialog.row = row
        params.ids.push(row.id)
        titleArr.push(row.name)
        msg = type === 'up' ? `是否上架【${row.name}】, 是否继续?` : `是否下架【${row.name}】, 是否继续?`
      } else {
        this.list.forEach(e => {
          selectionId.forEach(s => {
            if (e.id === s) {
              titleArr.push(e.name)
            }
          })
        })
        params.ids = selectionId

      }
      // console.log(selectionId.length, type, selectionId)
      if (params.ids.length === 0) { return this.$message({ type: 'error', message: '需要选择商品!' }) }

      if (type === 'up') {
        const findObj = selectionGoods.find(e => { return e.status === 1 })
        if (findObj) { return this.$message({ type: 'error', message: '已有商品上架!' }) }
      }
      if (type === 'down') {
        this.$api.giftListByGoodId(params.ids).then((res) => {
          if (res.data.length > 0) {
            this.giftListByGoodId = res.data
            return this.showModifyState(type, titleArr)
          } else {
            return this.onUpDownOperation(type, params, msg)
          }
        }).catch((err) => {
          // console.log(err)
        })
        // setTimeout(() => {}, 1000)
        const findObj = selectionGoods.find(e => { return e.status === 0 })
        // if (findObj) { return this.$message({ type: 'error', message: '已有商品下架!' }) }
      } else {
        this.onUpDownOperation(type, params, msg)
      }
    },
    onUpDownOperation(type, params, msg) {
      let operationFun
      this.$confirm(msg, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        switch (type) {
          case 'up':
            operationFun = this.$api.goodsPutOn
            // this.column = columnConsumption
            break
          // 分配记录
          case 'down':
            operationFun = this.$api.goodsPutOff
            break
          // default:
        }
        operationFun(params).then((res) => {
          this.fetchData()
          this.$message({ type: 'success', message: '操作成功!' })
        }).catch((err) => {
          console.log(err)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    showModifyState(skuList, titleArr) {
      // console.log('showModifyState', skuList, titleArr)
      this.setCloseOrder = ''
      this.dialog.visible = true
      this.dialog.title = '下架提示'
      this.dialog.width = '640px'
      this.dialog.type = 'modifyState'
      // this.dialog.row = row
      this.dialog.titleArr = titleArr
      // this.dialog.list = row.skuList
      // this.cancelOrderId = row.orderId
      // console.log('getGoodCopySku', this.dialog.list)
    },
    // 根据商品id,获取礼包列表查询接口
    onGiftListByGoodId(ids) {
      // const params = { goodsIds: ids }
      this.$api.giftListByGoodId(ids).then((res) => {
        console.log(res)
        return res
      }).catch((err) => {
        // console.log(err)
        return res
      })
    },
    // 删除商品
    onGoodsDelete(row) {
      const msg = `此操作将删除【${row.name}】, 是否继续?`
      this.$confirm(msg, '提示', {
        title: '删除商品',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'error'
      }).then(() => {
        const params = { id: row.id }
        this.$api.goodsDelete(params).then((res) => {
          this.fetchData()
          this.$message({ type: 'success', message: '操作成功!' })
        }).catch((err) => {
          console.log(err)
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    toOtherPages(name, parameter, type) {
      this.$router.push({
        name,
        query: { id: parameter.id, type, oType: parameter.isMyOutput }
      })
    },
    // 获取 商品 KSU
    getGoodCopySku(skuList, row) {
      this.setCloseOrder = ''
      this.dialog.visible = true
      this.dialog.title = '复制SKU码'
      this.dialog.width = '640px'
      this.dialog.type = 'skuList'
      this.dialog.list = row.skuList
      // this.cancelOrderId = row.orderId
      // console.log('getGoodCopySku', this.dialog.list)
    },
    // 复制 KSU
    onCopySku(info) {
      // console.log('onCopySku', info)
      const t = this
      this.$copyText(info).then(
        function (e) {
          t.$message({
            type: 'success',
            message: '复制成功'
          })
        },
        function (e) {
          t.$message({
            type: 'warning',
            message: '复制失败'
          })
        }
      )
    },
    // 商品导出
    onGoodsExport() {
      this.GoodsExportLoading = true
      let params = {
        pageNo: this.page.pageNo,
        pageSize: this.page.pageSize,
        status: this.currentTab
      }
      params = Object.assign(params, this.searchForm)
      // 类目id
      const tempCategoryIdArr = [].concat(params.categoryId)
      if (tempCategoryIdArr && tempCategoryIdArr.length !== 0) {
        params.categoryId = tempCategoryIdArr[tempCategoryIdArr.length - 1]
      }
      for (const item in params) {
        if (typeof params[item] === 'string') {
          params[item] = params[item].trim()
          if (params[item] === '') { delete params[item] }
        }
      }
      this.$api.goodsExport(params).then((res) => {
        this.GoodsExportLoading = false
        this.downloadlink(res.data)
        this.$message.success('操作成功！')
      }).catch((err) => {
        this.GoodsExportLoading = false
        console.log(err)
      })
    }
  }
}
</script>
<style  lang="scss">
.el-cascader-panel {
  .el-scrollbar:first-child {
    .el-checkbox {
      display: none;
    }
  }
}
</style>
<style scoped lang="scss">
@import "@/assets/styles/modifyState.scss";

.info {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 30px;
  color: #303033;
  opacity: 1;
  text-align: center;
}

.info-b {
  margin-left: 20px;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  line-height: 40px;
  color: #303033;
  text-align: left;
}

.info-q {
  width: 124px;
  height: 40px;
  line-height: 40px;
  background: #ffffff;
  border: 1px solid #909099;
  opacity: 1;
  border-radius: 3px;
  text-align: center;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #909099;
  margin-right: 18px;
  cursor: pointer;
}

.info-s {
  width: 126px;
  height: 40px;
  line-height: 40px;
  background: #2d46ee;
  opacity: 1;
  border-radius: 3px;
  text-align: center;
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  cursor: pointer;
}

::v-deep .el-switch__label {
  position: absolute;
  display: none;
  color: #fff;
}

/*打开时文字位置设置*/
::v-deep .el-switch__label--right {
  z-index: 1;
  right: 20px;
}

/*关闭时文字位置设置*/
::v-deep .el-switch__label--left {
  z-index: 1;
  left: 20px;
}

/*显示文字*/
::v-deep .el-switch__label.is-active {
  display: block;
}

::v-deep .el-switch .el-switch__core,
.el-switch .el-switch__label {
  width: 60px;
}

::v-deep .el-radio-button__orig-radio:checked+.el-radio-button__inner {
  color: #2d46ee;
  background-color: #fff !important;
  border-color: #2d46ee;
  box-shadow: -1px 0 0 0 #2d46ee;
}

.dialog-search {
  margin-top: 4px;
}

.dialog-button {
  margin-top: 6px;
}

.dialog-pagination {
  margin-top: 20px;
  margin-bottom: 20px;
  float: right;
}

.platform {
  margin: 20px 20px;

  .el-radio {
    padding: 10px 10px;
  }
}

/deep/.hide-content {
  display: none !important;
}

//删除全页面按钮边框
// .el-button {
//   border: none;
// }
// 按钮
.btn-list {
  margin-bottom: 22px;
  display: flex;

  .item {
    flex: 1;

    &:last-child {
      text-align: right;

      .el-button {
        width: 120px;

        // color: #2d7edf;
        // border: 1px solid #2d7edf;
        &:last-child,
        .goods-export {
          color: #ffffff;
          // border: 1px solid #409eff;
        }
      }

      .el-button--warning {
        background-color: #ff9226;
      }

      .goods-export {
        color: #ffffff;
        // border: 1px solid #409eff;
      }
    }

    .el-button {
      height: 36px;
      line-height: 36px;
      padding-top: 0;
      padding-bottom: 0;
    }

    .is-disabled {
      background-color: #f4f4f5 !important;
      border: 1px solid #d3d4d6 !important;
      color: #909399 !important;
    }

    /deep/ .el-radio-button__inner {
      padding: 8px 20px;
    }
  }
}

.search-form {
  display: flex;
  flex-wrap: wrap;

  .el-form-item {
    /deep/ .el-form-item__label {
      width: 82px;
      text-align: right;
      vertical-align: middle;
      float: left;
      box-sizing: border-box;
    }

    /deep/ .el-form-item__content {
      display: block;
      margin-left: 82px;

      .el-cascader,
      .el-select {
        width: 100%;
      }
    }
  }
}

/deep/.el-scrollbar {
  height: 10px;
}

/deep/.el-scrollbar__bar.is-horizontal {
  height: 9px;
}

:deep(#base-list .lb-table .el-table .el-table__body .el-table__row .el-table__cell:last-child .cell div) {
  display: inline-block;

  a {
    margin: 0 5px;
  }
}
</style>
